/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type BacktestPositionEpisodeResponse = {
    run_id: string;
    episode_id: string;
    symbol: string;
    status: BacktestPositionEpisodeResponse.status;
    opened_trading_day: string;
    closed_trading_day?: (string | null);
    opened_at: string;
    closed_at?: (string | null);
    realized_pnl: string;
    closed_cost_basis: string;
    realized_return_rate: (string | null);
    holding_period_days: number;
};
export namespace BacktestPositionEpisodeResponse {
    export enum status {
        OPEN = 'OPEN',
        CLOSED = 'CLOSED',
    }
}

